import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Elements } from 'react-stripe-elements';

import ActivateCreditTrial from './ActivateCreditTrial';
import ActivateV2 from './ActivateSubscriptionV2';

class Activate extends Component {
  componentDidMount() {
    fbq("track", "InitiateCheckout"); // eslint-disable-line

    ReactGA.initialize('UA-49918148-2');
    ReactGA.pageview(window.location.pathname + window.location.search);

    window.scrollTo(0, 0);
  }

  render() {
    // TODO: Get ActivateV1 working again and provide a route for Sean
    const { pathname } = window.location;
    if (pathname == '/activate') {
      return (
        <Elements>
          <ActivateV2 />
        </Elements>
      );
    }
    if (pathname == '/trial') {
      return (
        <Elements>
          <ActivateCreditTrial />
        </Elements>
      );
    }
    return null;
  }
}

export default Activate;



// WEBPACK FOOTER //
// ./src/pages/student/Activate/index.js